export default __webpack_public_path__ + "static/media/cd.2285fef6.svg";